import React from "react";
import { TabProvider } from "./context";
import { TabNavigator } from "./tabNavigator";

export const TabLayout = ({ activeTabId, setActiveTabId, initialTab, children }) => (
  <TabProvider activeTabId={activeTabId} setActiveTabId={setActiveTabId}>
    <TabNavigator initialTab={initialTab} />
    {children}
  </TabProvider>
);